import { authRoles } from './auth/authRoles';

export const navigationsTypeB = [
  {
    name: 'HOME',
    path: '/storehome',
    icon: 'home',
  },
  {
    name: 'ブランド',
    icon: 'storefront',
    children: [
      {
        name: 'ブランド新規登録',
        path: '/createbrand',
        authority: 1,
      },
      {
        name: 'ブランド編集・削除',
        path: '/brandlist',
        authority: 1,
      }
    ],
  },
  {
    name: '店舗',
    icon: 'storefront',
    children: [
      {
        name: '店舗新規登録',
        path: '/storeregist',
        authority: 1,
      },
      {
        name: '店舗編集・削除',
        path: '/storeedit',
        authority: 2,
      }/*,
      {
        name: '店舗を選択する',
        path: '/storehome',
      }*/
    ],
  },
  {
    name: 'プッシュ情報（一括登録・配信）',
    icon: 'notifications_all',
    children: [
      {
        name: 'プッシュ情報通知',
        path: '/PushNotificationAllCreate',
        authority: 1,
      },
      {
        name: 'プッシュ情報編集・削除',
        path: '/PushNotificationAllEdit',
        authority: 1,
      },
    ],
  },
  {
    name: 'クーポン（一括登録・配信）',
    icon: 'insert_drive_file',
    children: [
      {
        name: '新規クーポン登録',
        path: '/CouponAllCreate',
        authority: 1,
      },
      {
        name: 'クーポン編集・削除',
        path: '/CouponAllEdit',
        authority: 1,
      },
    ],
  },
  {
    name: 'テーブルオーダー（一括登録・配信）',
    icon: 'tablet',
    children: [
      {
        name: 'TTO・広告画像・映像登録',
        path: '/TableOrderAll',
        authority: 2,
      },
      {
        name: 'ホーム画面動画URL設定',
        path: '/HomeVideoAll',
        authority: 1,
      },
      /*
      {
        name: '商品登録（隠しメニュー）',
        path: '/HiddenMenu',
      },
      */
    ],
  },
  {
    // 店舗未選択（全店舗）時のみ表示。storeId = 9999 固定で登録・編集する
    name: 'イートイン商品（全店舗）',
    icon: 'restaurant',
    allShop: true,
    children: [
      {
        name: 'カテゴリ登録    ',
        path: '/categoryeatinall',
        authority: 1,
      },
      {
        name: 'トッピング登録    ',
        path: '/toppingeatinall',
        authority: 1,
      },
      {
        name: '商品登録    ',
        path: '/producteatinall',
        authority: 1,
      }
    ],
  },
  {
    // 店舗未選択（全店舗）時のみ表示。storeId = 9999 固定で登録・編集する
    name: 'テイクアウト商品（全店舗）',
    icon: 'takeout_dining',
    allShop: true,
    children: [
      {
        name: 'カテゴリ登録     ',
        path: '/categorytakeoutall',
        authority: 1,
      },
      {
        name: 'トッピング登録     ',
        path: '/toppingtakeoutall',
        authority: 1,
      },
      {
        name: '商品登録     ',
        path: '/producttakeoutall',
        authority: 1,
      }
    ],
  },
  {
    // 店舗未選択（全店舗）時のみ表示。storeId = 9999 固定で登録・編集する
    name: 'デリバリー商品（全店舗）',
    icon: 'directions_bike',
    allShop: true,
    children: [
      {
        name: 'カテゴリ登録      ',
        path: '/categorydeliveryall',
        authority: 1,
      },
      {
        name: 'トッピング登録      ',
        path: '/toppingdeliveryall',
        authority: 1,
      },
      {
        name: '商品登録      ',
        path: '/productdeliveryall',
        authority: 1,
      }
    ],
  },
  {
    name: 'アプリ営業時間設定',
    path: '/storebusinesshours',
    icon: 'schedule',
    type: 'storebusinesshours',
  },
  /*{
    name: 'カウント商品（確認用）',
    path: '/countproduct',
    icon: 'storefront',
  },*/
  {
    name: 'イートイン商品',
    icon: 'restaurant',
    children: [
      {
        name: 'カテゴリ登録 ',
        path: '/categoryeatin',
        authority: 2,
      },
      {
        name: 'トッピング登録 ',
        path: '/toppingeatin',
        authority: 2,
      },
      {
        name: 'メニュー種別登録 ',
        path: '/mcategoryeatin',
        authority: 2,
      },
      {
        name: '商品登録 ',
        path: '/producteatin',
        authority: 2,
      }/*,
      {
        name: 'Recommend商品 ',
        path: '/producteatininbound',
        authority: 2,
      }*/
    ],
  },
  {
    name: 'テイクアウト商品',
    icon: 'takeout_dining',
    children: [
      {
        name: 'カテゴリ登録  ',
        path: '/categorytakeout',
        authority: 2,
      },
      {
        name: 'トッピング登録  ',
        path: '/toppingtakeout',
        authority: 2,
      },
      {
        name: '商品登録  ',
        path: '/producttakeout',
        authority: 2,
      }
    ],
  },
  {
    name: 'デリバリー商品',
    icon: 'directions_bike',
    children: [
      {
        name: 'カテゴリ登録   ',
        path: '/categorydelivery',
        authority: 2,
      },
      {
        name: 'トッピング登録   ',
        path: '/toppingdelivery',
        authority: 2,
      },
      {
        name: '商品登録   ',
        path: '/productdelivery',
        authority: 2,
      }
    ],
  },
  {
    name: 'クーポン',
    icon: 'insert_drive_file',
    children: [
      {
        name: '新規クーポン登録',
        path: '/CouponCreate',
        authority: 2,
      },
      {
        name: 'クーポン編集・削除',
        path: '/CouponEdit',
        authority: 2,
      },
    ],
  },
  {
    name: 'プッシュ情報',
    icon: 'notifications',
    children: [
      {
        name: 'プッシュ情報通知',
        path: '/PushNotificationCreate',
        authority: 2,
      },
      {
        name: 'プッシュ情報編集・削除',
        path: '/PushNotificationEdit',
        authority: 2,
      },
    ],
  },
  {
    name: 'テーブルオーダー',
    icon: 'tablet',
    children: [
      {
        name: 'TTO・広告画像・映像登録',
        path: '/TableOrder',
        authority: 2,
      },
      {
        name: 'ホーム画面動画URL設定',
        path: '/HomeVideoUrl',
        authority: 2,
      },
      /*
      {
        name: '商品登録（隠しメニュー）',
        path: '/HiddenMenu',
      },
      */
    ],
  },

]

export const navigations = [
  {
    name: 'HOME',
    path: '/home',
    icon: 'home',
  },
  // {
  //   name: '店舗検索',
  //   path: '/shop/search',
  //   icon: 'search', //MatxVerticalNav.jsx iconない場合の点
  // },
  //{
  //  name: '現金管理',
  //  path: '/cash',
  //  icon: 'local_atm_icon',
  //},
  {
    name: '売上',
    icon: 'trending_up',
    children: [
      //{
      //  name: '売上',
      //  path: '/sales/search',
      //},
      {
        name: '期間売上',
        path: '/salesterm',
        authority: 2,
      },
      {
        name: '時間帯売上',
        path: '/salestimezone',
        authority: 2,
      },
      {
        name: 'カテゴリ別売上',
        path: '/salescategory',
        authority: 2,
      },
      {
        name: '商品別売上',
        path: '/salesitems',
        authority: 2,
      },
      {
        name: 'カウント商品出数',
        path: '/countproductoverview',
        authority: 2,
      }
      //{
      //  name: '日別詳細',
      //  path: '/salesdaily',
      //},
    ],
  },
  {
    name: '取引履歴（電子ジャーナル）',
    path: '/tradinghistory',
    icon: 'receipt_long',
  },
  {
    name: '日次処理',
    icon: 'fact_check',
    children: [
      {
        name: '日次・月次締め',
        path: '/dailyclosing',
        authority: 2,
      },
      {
        name: 'VOID処理',
        path: '/voidlist',
        authority: 2,
      }
    ],
  },
  {
    name: 'AI（人工知能）',
    icon: 'psychology',
    children: [
      {
        name: '日替わりメニュー生成',
        path: '/dailymenugenerator',
        authority: 2,
      },
    ],
  },

  // {
  //   name: 'IR開示情報',
  //   path: '/ir',
  //   icon: 'assignment_icon',
  // },
  //////////////////////////////////////////////////////////////////
  // {
  //   name: '店舗分析',
  //   icon: 'dvr_icon',
  //   children: [
  //     {
  //       name: '売上比較',
  //       path: '/analytics-sales',
  //     },
  //     {
  //       name: '非既存店・既存店分析',
  //       path: '/analytics-shop',
  //     },
  //   ],
  // },
  //////////////////////////////////////////////////////////////////
  // {
  //   name: 'メニュー売上分析',
  //   icon: 'restaurant_icon',
  //   children: [
  //     {
  //       name: 'オーダー率ランキング',
  //       path: '/ranking-order',
  //     },
  //     {
  //       name: '部門別ABC表',
  //       path: '/dept-abc',
  //     },
  //     {
  //       name: 'ABC表',
  //       path: '/abc',
  //     },
  //     {
  //       name: 'ﾒﾆｭｰ別点数ﾗﾝｷﾝｸﾞ[日別]',
  //       path: '/ranking-menu',
  //     },
  //     {
  //       name: '店舗別メニュー別構成比',
  //       path: '/menu-ratio',
  //     },
  //   ],
  // },
  //////////////////////////////////////////////////////////////////
  // {
  //   name: '仕入明細',
  //   icon: 'print_icon',
  //   children: [
  //     {
  //       name: '仕入明細表',
  //       path: '/purchase-detail',
  //     },
  //     {
  //       name: '店舗仕入実績',
  //       path: '/purchase-record',
  //     },
  //     {
  //       name: '月別業態地区別仕入数量',
  //       path: '/purchase-quantity',
  //     },
  //     {
  //       name: '店舗別食材売上推移（月次）',
  //       path: '/purchase-transition',
  //     },
  //     {
  //       name: '食材売上額・生餃子\n出荷数前年比（店・月別）',
  //       path: '/purchase-shipping',
  //     },
  //     {
  //       name: '食材売上検証',
  //       path: '/purchase-inspect',
  //     },
  //   ],
  // },
  //////////////////////////////////////////////////////////////////
  // {
  //   name: '営業日報',
  //   icon: 'edit_icon',
  //   children: [
  //     {
  //       name: '入力',
  //       path: '/report-input',
  //     },
  //     {
  //       name: '閲覧',
  //       path: '/report-browse',
  //     },
  //   ],
  // },
  //////////////////////////////////////////////////////////////////
  // {
  //   name: 'キングオブ大阪王将',
  //   icon: 'star_icon',
  //   children: [
  //     {
  //       name: '売上部門',
  //       path: '/king-order',
  //     },
  //     {
  //       name: '客数部門',
  //       path: '/king-customer',
  //     },
  //     {
  //       name: '餃子部門',
  //       path: '/king-gyoza',
  //     },
  //     {
  //       name: '販促部門',
  //       path: '/king-sales',
  //     },
  //     {
  //       name: '店舗運営力部門',
  //       path: '/king-manage',
  //     },
  //     {
  //       name: 'ナホオーダー',
  //       path: '/king-naho',
  //     },
  //     {
  //       name: '指定食材減点',
  //       path: '/king-food',
  //     },
  //     {
  //       name: '総合順位',
  //       path: '/king-rank',
  //     },
  //   ],
  // },
  //////////////////////////////////////////////////////////////////

  // {
  //   name: '開発用画面',
  //   path: '/develop',//dashboardの中に
  // },
  // {
  //   name: 'Develop',
  //   children: [
  //     {
  //       name: 'Dashboard', //サイドバーの名前表示
  //       path: '/dashboard', //DashboardRoutes.jsの./Analytics2
  //       icon: 'dashboard',
  //     },
  //     {
  //       name: 'Alternative',
  //       path: '/alternative',
  //       icon: 'analytics',
  //     },
  //     {
  //       name: 'Inventory Management',
  //       path: '/inventory-management',
  //       icon: 'store',
  //     },
  //     {
  //       name: 'Customers',
  //       icon: 'people',
  //       children: [
  //         {
  //           name: 'Customer List',
  //           path: '/pages/customer-list',
  //           iconText: 'CL',
  //         },
  //         {
  //           name: 'View Customer',
  //           path: '/pages/view-customer',
  //           iconText: 'VC',
  //         },
  //         {
  //           name: 'New Customer',
  //           path: '/pages/new-customer',
  //           iconText: 'NC',
  //         },
  //         {
  //           name: 'User Profile',
  //           path: '/page-layouts/user-profile',
  //           // icon: 'person',
  //         },
  //       ],
  //     },
  //     {
  //       name: 'Products',
  //       icon: 'shopping_cart',
  //       children: [
  //         {
  //           name: 'Product List',
  //           path: '/pages/product-list',
  //           iconText: 'PL',
  //         },
  //         {
  //           name: 'View Product',
  //           path: '/pages/view-product',
  //           iconText: 'VP',
  //         },
  //         {
  //           name: 'New Product',
  //           path: '/pages/new-product',
  //           iconText: 'NP',
  //         },
  //       ],
  //     },
  //     {
  //       name: 'Orders',
  //       icon: 'folder',
  //       children: [
  //         {
  //           name: 'Order List',
  //           path: '/pages/order-list',
  //           iconText: 'OL',
  //         },
  //         {
  //           name: 'View Order',
  //           path: '/invoice/fdskfjdsuoiucrwevbgd',
  //           iconText: 'VO',
  //         },
  //       ],
  //     },
  //     {
  //       name: 'Help Center',
  //       icon: 'help',
  //       children: [
  //         {
  //           name: 'FAQ 1',
  //           path: '/pages/faq-1',
  //           iconText: 'F1',
  //         },
  //         {
  //           name: 'FAQ 2',
  //           path: '/pages/faq-2',
  //           iconText: 'F2',
  //         },
  //       ],
  //     },
  //     {
  //       name: 'Pricing',
  //       icon: 'money',
  //       children: [
  //         {
  //           name: 'Pricing 1',
  //           iconText: 'P1',
  //           path: '/others/pricing-1',
  //         },
  //         {
  //           name: 'Pricing 2',
  //           iconText: 'P2',
  //           path: '/others/pricing-2',
  //         },
  //         {
  //           name: 'Pricing 3',
  //           iconText: 'P3',
  //           path: '/others/pricing-3',
  //         },
  //         {
  //           name: 'Pricing 4',
  //           iconText: 'P4',
  //           path: '/others/pricing-4',
  //         },
  //       ],
  //     },
  //     {
  //       name: 'User List',
  //       icon: 'people',
  //       children: [
  //         {
  //           name: 'User List 1',
  //           path: '/pages/user-list-1',
  //           iconText: 'U1',
  //         },
  //         {
  //           name: 'User List 2',
  //           path: '/pages/user-list-2',
  //           iconText: 'U2',
  //         },
  //         {
  //           name: 'User List 3',
  //           path: '/pages/user-list-3',
  //           iconText: 'U3',
  //         },
  //         {
  //           name: 'User List 4',
  //           path: '/pages/user-list-4',
  //           iconText: 'U3',
  //         },
  //       ],
  //     },
  //     {
  //       name: 'Forms',
  //       icon: 'description',
  //       children: [
  //         {
  //           name: 'Order Form',
  //           path: '/forms/order-form',
  //           iconText: 'OF',
  //         },
  //         {
  //           name: 'Invoice Form',
  //           path: '/forms/invoice-form',
  //           iconText: 'IF',
  //         },
  //         {
  //           name: 'Property Listing Form',
  //           path: '/forms/property-listing-form',
  //           iconText: 'PF',
  //         },
  //         {
  //           name: 'Basic',
  //           path: '/forms/basic',
  //           iconText: 'B',
  //         },
  //         {
  //           name: 'Editor',
  //           path: '/forms/editor',
  //           iconText: 'E',
  //         },
  //         {
  //           name: 'Upload',
  //           path: '/forms/upload',
  //           iconText: 'U',
  //         },
  //         {
  //           name: 'Wizard',
  //           path: '/forms/wizard',
  //           iconText: 'W',
  //         },
  //       ],
  //     },
  //     {
  //       name: 'Matx List',
  //       icon: 'list',
  //       children: [
  //         {
  //           name: 'Infinite Scroll',
  //           path: '/infinite-scroll',
  //           iconText: 'I',
  //         },
  //         {
  //           name: 'List',
  //           path: '/matx-list',
  //           iconText: 'L',
  //         },
  //       ],
  //     },
  //     {
  //       name: 'Session/Auth',
  //       icon: 'security',
  //       children: [
  //         {
  //           name: 'Sign in',
  //           iconText: 'SI',
  //           path: '/session/signin',
  //         },
  //         {
  //           name: 'Sign up',
  //           iconText: 'SU',
  //           path: '/session/signup',
  //         },
  //         {
  //           name: 'Forgot Password',
  //           iconText: 'FP',
  //           path: '/session/forgot-password',
  //         },
  //         {
  //           name: 'Error',
  //           iconText: '404',
  //           path: '/session/404',
  //         },
  //       ],
  //     },

  //     {
  //       label: 'Apps',
  //       type: 'label',
  //     },
  //     {
  //       name: 'Ecommerce',
  //       icon: 'shopping_basket',
  //       children: [
  //         {
  //           name: 'Shop',
  //           path: '/ecommerce/shop',
  //           iconText: 'S',
  //         },
  //         {
  //           name: 'Cart',
  //           path: '/ecommerce/cart',
  //           iconText: 'C',
  //         },
  //         {
  //           name: 'Checkout',
  //           path: '/ecommerce/checkout',
  //           iconText: 'CO',
  //         },
  //       ],
  //     },

  //     {
  //       name: 'APP',
  //       children: [
  //         {
  //           name: 'Scrum Board',
  //           // icon: 'group_work',
  //           path: '/scrum-board/c5d7498bbcb84d81fc7454448871ac6a6e',
  //         },
  //         {
  //           name: 'Invoice Builder',
  //           // icon: 'receipt',
  //           path: '/invoice/list',
  //         },
  //         {
  //           name: 'Calendar',
  //           // icon: 'date_range',
  //           path: '/calendar',
  //         },
  //         {
  //           name: 'Chat',
  //           // icon: 'chat',
  //           path: '/chat',
  //         },
  //         {
  //           name: 'Inbox',
  //           // icon: 'inbox',
  //           path: '/inbox',
  //         },
  //         {
  //           name: 'Todo',
  //           // icon: 'center_focus_strong',
  //           path: '/todo/list',
  //         },
  //       ]
  //     },


  //     {
  //       label: 'Components',
  //       type: 'label',
  //     },
  //     {
  //       name: 'Components',
  //       icon: 'favorite',
  //       badge: { value: '30+', color: 'secondary' },
  //       children: [
  //         {
  //           name: 'Auto Complete',
  //           path: '/material/autocomplete',
  //           iconText: 'A',
  //         },
  //         {
  //           name: 'Buttons',
  //           path: '/material/buttons',
  //           iconText: 'B',
  //         },
  //         {
  //           name: 'Checkbox',
  //           path: '/material/checkbox',
  //           iconText: 'C',
  //         },
  //         {
  //           name: 'Dialog',
  //           path: '/material/dialog',
  //           iconText: 'D',
  //         },
  //         {
  //           name: 'Drag and Drop',
  //           iconText: 'D',
  //           path: '/others/drag-and-drop',
  //         },
  //         {
  //           name: 'Expansion Panel',
  //           path: '/material/expansion-panel',
  //           iconText: 'E',
  //         },
  //         {
  //           name: 'Form',
  //           path: '/material/form',
  //           iconText: 'F',
  //         },
  //         {
  //           name: 'Icons',
  //           path: '/material/icons',
  //           iconText: 'I',
  //         },
  //         {
  //           name: 'Menu',
  //           path: '/material/menu',
  //           iconText: 'M',
  //         },
  //         {
  //           name: 'Progress',
  //           path: '/material/progress',
  //           iconText: 'P',
  //         },
  //         {
  //           name: 'Radio',
  //           path: '/material/radio',
  //           iconText: 'R',
  //         },
  //         {
  //           name: 'Switch',
  //           path: '/material/switch',
  //           iconText: 'S',
  //         },
  //         {
  //           name: 'Slider',
  //           path: '/material/slider',
  //           iconText: 'S',
  //         },
  //         {
  //           name: 'Snackbar',
  //           path: '/material/snackbar',
  //           iconText: 'S',
  //         },
  //         {
  //           name: 'Table',
  //           path: '/material/table',
  //           iconText: 'T',
  //         },
  //         {
  //           name: 'Map',
  //           // icon: 'add_location',
  //           path: '/map',
  //         },
  //         {
  //           name: 'Left Sidebar Card',
  //           path: '/page-layouts/Left-sidebar-card',
  //           // icon: 'vertical_split',
  //         },
  //       ],
  //     },
  //     {
  //       name: 'Utilities',
  //       icon: 'format_list_bulleted',
  //       children: [
  //         {
  //           name: 'Color',
  //           path: '/utilities/color',
  //           iconText: 'C',
  //           auth: authRoles.admin,
  //         },
  //         {
  //           name: 'Spacing',
  //           path: '/utilities/spacing',
  //           iconText: 'S',
  //           auth: authRoles.admin,
  //         },
  //         {
  //           name: 'Typography',
  //           path: '/utilities/typography',
  //           iconText: 'T',
  //         },
  //         {
  //           name: 'Display',
  //           path: '/utilities/display',
  //           iconText: 'D',
  //         },
  //         {
  //           name: 'Position',
  //           path: '/utilities/position',
  //           iconText: 'P',
  //         },
  //         {
  //           name: 'Shadow',
  //           path: '/utilities/shadow',
  //           iconText: 'S',
  //         },
  //       ],
  //     },

  //     {
  //       name: 'Charts',
  //       icon: 'trending_up',
  //       children: [
  //         {
  //           name: 'Echarts',
  //           path: '/charts/echarts',
  //           iconText: 'E',
  //         },
  //         {
  //           name: "Recharts",
  //           path: "/charts/recharts",
  //           iconText: "R",
  //         },
  //         {
  //           name: 'React Vis',
  //           path: '/charts/react-vis',
  //           iconText: 'R',
  //         },
  //         {
  //           name: 'Victory Chart',
  //           path: '/charts/victory-charts',
  //           iconText: 'V',
  //         },
  //       ],
  //     },

  //     {
  //       name: 'Data Table',
  //       icon: 'table_view',
  //       children: [
  //         {
  //           name: 'CRUD Table',
  //           // icon: 'format_list_bulleted',
  //           path: '/crud-table',
  //         },
  //         {
  //           name: 'Simple Mui Table',
  //           path: '/data-table/simple-mui-table',
  //           iconText: 'T1',
  //         },
  //         {
  //           name: 'Expandable Mui Table',
  //           path: '/data-table/expandable-mui-table',
  //           iconText: 'T2',
  //         },
  //       ],
  //     },
  //     {
  //       name: 'Documentation',
  //       // icon: 'launch',
  //       type: 'extLink',
  //       path: 'http://demos.ui-lib.com/matx-react-doc/',
  //     },
  //   ]
  // },

  /////////////////////////////////
];
